import { apiClient } from "./Api";


export async function fetchAvailableLanguages(companyId: number, productId: number) {
  const { data: response } = await apiClient.get(
    `/api/companies/${companyId}/products/${productId}/localizations/available-languages`
  );
  return response.languages;
}

export async function fetchLocalizedLanguage(companyId: number, productId: number, languageCode: string) {
  const { data: response } = await apiClient.get(
    `/api/companies/${companyId}/products/${productId}/localizations/${languageCode}`
  );
  return response;
}

export async function createLocalizationContent(
  companyId: number,
  productId: number,
  languageCode: string,
  sourceLanguageCode: string | null
) {
  const { data: response } = await apiClient.post(
    `/api/companies/${companyId}/products/${productId}/localizations`,
    { languageCode: languageCode, sourceLanguage: sourceLanguageCode }
  );
  return response;
}

export async function getCurrentLocalization(companyId: number, productId: number, languageCode: string) {
    const { data: response } = await apiClient.get(
        `/api/companies/${companyId}/products/${productId}/localizations/${languageCode}`
    );
    return response;
}

// export async function fetchLocalizationContent(
//   productId: number,
//   languageCode: string
// ) {
//   const { data: response } = await apiClient.get(
//     `/api/products/${productId}/localizations/${languageCode}`
//   );
//   return response.content;
// }

export async function updateLocalizedContent(
  companyId: number,
  productId: number,
  languageCode: string,
  payLoad: object
) {
  const { data: response } = await apiClient.put(
    `/api/companies/${companyId}/products/${productId}/localizations/${languageCode}`,
    payLoad
  );
  return response.content;
}

export async function publishLocalizedContent(
  companyId: number,
  productId: number,
  languageCode: string
) {
  const { data: response } = await apiClient.post(
    `/api/companies/${companyId}/products/${productId}/localizations/${languageCode}/publish`
  );
  return response;
}

export async function unpublishLocalizedContent(
  companyId: number,
  productId: number,
  languageCode: string
) {
  const { data: response } = await apiClient.post(
    `/api/companies/${companyId}/products/${productId}/localizations/${languageCode}/unpublish`
  );
  return response;
}

// CTAs for localization
export async function fetchLocalizedCTA(companyId: number, productId: number, languageCode: string) {
  const { data: response } = await apiClient.get(
    `/api/companies/${companyId}/products/${productId}/localizations/${languageCode}/cta`
  );
  return response;
}

export async function updateLocalizedCTA(
  companyId: number,
  productId: number,
  languageCode: string,
  payLoad: object
) {
  const { data: response } = await apiClient.put(
    `/api/companies/${companyId}/products/${productId}/localizations/${languageCode}/cta`,
    payLoad
  );
  return response;
}